import { defineComponent as _defineComponent } from 'vue'
import FpSvgIcon from '@/components/fpComponents/FpSvgIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LendaIcon',
  props: {
  src: {
    type: String,
    required: true,
  },
  width: {
    type: [Number, String],
  },
  height: {
    type: [Number, String],
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, FpSvgIcon }
}

})